var map = {
	"./404.svg": 940,
	"./Categories.png": 941,
	"./Edit-menu.svg": 942,
	"./Egg.svg": 943,
	"./Emaier-Header.png": 944,
	"./Qr-4.png": 945,
	"./_duplicate.svg": 946,
	"./_overview.svg": 947,
	"./add-white.svg": 948,
	"./alert.svg": 949,
	"./all_category.svg": 950,
	"./archive.svg": 951,
	"./armchair.svg": 952,
	"./arrow-circle-right.svg": 953,
	"./arrow-left-circle.svg": 954,
	"./arrow-right-circle.svg": 955,
	"./arrow-right.svg": 352,
	"./asc-up-white.svg": 956,
	"./asc.png": 957,
	"./asc.svg": 958,
	"./back-arrow.svg": 959,
	"./barcode-icon.svg": 960,
	"./beverages.svg": 961,
	"./blue-edit-pen.svg": 962,
	"./blue-eye.svg": 963,
	"./box-office.svg": 964,
	"./broken-seat.jpg": 965,
	"./calendar_list.svg": 966,
	"./chevron-down.svg": 967,
	"./chevron-left.svg": 968,
	"./cinema-mamagement-sidebar.svg": 969,
	"./claendar.svg": 302,
	"./clock-1.svg": 970,
	"./clock.svg": 971,
	"./close-button.svg": 700,
	"./close-white.svg": 703,
	"./close-x.svg": 297,
	"./collapse-up.svg": 972,
	"./collapse.svg": 973,
	"./connection-lost.svg": 350,
	"./copy.svg": 974,
	"./copy_image_icon.png": 975,
	"./delete-red-light.svg": 976,
	"./delete-red.svg": 709,
	"./delete.svg": 686,
	"./deliver-icon.svg": 977,
	"./desc-down-white.svg": 978,
	"./desc.svg": 979,
	"./distributors-sidebar.svg": 980,
	"./download.svg": 981,
	"./dragndrop.svg": 982,
	"./dragndrop2.svg": 983,
	"./duplicate.svg": 984,
	"./duplicateScreen.svg": 985,
	"./e-wallet-icon-black.svg": 986,
	"./edit-pen-blue.svg": 987,
	"./edit-pen-white.svg": 988,
	"./edit-pen.svg": 989,
	"./edit.svg": 990,
	"./email.png": 991,
	"./empty-image.svg": 992,
	"./excel.svg": 993,
	"./external-link.svg": 994,
	"./eye.svg": 995,
	"./filter-icon.svg": 996,
	"./flag.svg": 997,
	"./fnb-app-order.svg": 998,
	"./fnb-beverages.svg": 999,
	"./fnb-brownie.svg": 1000,
	"./fnb-combo.svg": 1001,
	"./fnb-desert.svg": 1002,
	"./fnb-eatables.svg": 1003,
	"./fnb-make-your-combo.svg": 1004,
	"./fnb-popcorn.svg": 1005,
	"./fnbtransactionIcon.svg": 1006,
	"./fullscreen-icon.svg": 710,
	"./funnel.svg": 1007,
	"./globe.svg": 1008,
	"./green-tick.svg": 1009,
	"./grid-view.svg": 1010,
	"./hide-password.svg": 353,
	"./home-icon.svg": 1011,
	"./home.svg": 1012,
	"./icon-black-play.svg": 1013,
	"./icon-dot.svg": 1014,
	"./icon-fnb.svg": 1015,
	"./icon-marketing.svg": 1016,
	"./icon-no-seat.png": 1017,
	"./icon-no-seat.svg": 1018,
	"./icon-option.svg": 1019,
	"./icon-poin-of-sale.svg": 1020,
	"./icon-recliner.svg": 1021,
	"./icon-report.svg": 1022,
	"./icon-sofa-dark-1.svg": 1023,
	"./icon-sofa-dark.png": 1024,
	"./icon-sofa-dark.svg": 1025,
	"./icon-sofa.svg": 1026,
	"./importfile.svg": 1027,
	"./info.svg": 704,
	"./info2.svg": 1028,
	"./keyboard-icon.svg": 1029,
	"./kitchen_display.svg": 1030,
	"./language-icon.svg": 298,
	"./left-caret.svg": 1031,
	"./link.svg": 1032,
	"./list-view.svg": 1033,
	"./loading.svg": 354,
	"./lock.svg": 1034,
	"./login-password.png": 355,
	"./login-user.png": 356,
	"./logout.svg": 705,
	"./masters-sidebar.svg": 1035,
	"./merchandise.svg": 1036,
	"./minus.svg": 1037,
	"./movie-pass-svg.svg": 692,
	"./movie-rolling.svg": 1038,
	"./mulitSchedule.svg": 1039,
	"./multicurrency.svg": 1040,
	"./multifnb.svg": 1041,
	"./nav-plus.svg": 1042,
	"./new_filter_icon.svg": 1043,
	"./no-image.svg": 1044,
	"./no-schedule.svg": 133,
	"./non-veg-mark.png": 1045,
	"./non-veg-mark.svg": 1046,
	"./notification.svg": 1047,
	"./open-link-blue.svg": 1048,
	"./openPlanned.svg": 1049,
	"./overview.svg": 1050,
	"./overview2.svg": 1051,
	"./pdf-icon.svg": 1052,
	"./pdf.svg": 1053,
	"./pickup-ticket-icon.svg": 1054,
	"./pickupfnb.svg": 1055,
	"./play.svg": 1056,
	"./plus.svg": 1057,
	"./pointofsale-1.svg": 1058,
	"./pointofsale-2.svg": 1059,
	"./pointofsale.png": 1060,
	"./portfolio.svg": 1061,
	"./pos-fnb-no-itmes.svg": 697,
	"./pos-refresh.svg": 1062,
	"./primary/chevron-down.svg": 1063,
	"./primary/download.svg": 1064,
	"./primary/edit.svg": 1065,
	"./primary/filter.svg": 1066,
	"./primary/printer.svg": 1067,
	"./print-icon.svg": 1068,
	"./print.svg": 1069,
	"./question.svg": 1070,
	"./question1.svg": 1071,
	"./question2.svg": 711,
	"./question3.svg": 1072,
	"./recliner-1.svg": 1073,
	"./recliner.png": 1074,
	"./refund-icon.svg": 1075,
	"./reload-icon-pos.svg": 1076,
	"./reload-icon.svg": 1077,
	"./restore.svg": 1078,
	"./right-caret.svg": 1079,
	"./role-management-sidebar.svg": 1080,
	"./save.svg": 1081,
	"./schedule-icon.svg": 1082,
	"./school-calendar.svg": 1083,
	"./search-global-white.svg": 1084,
	"./search-global.svg": 1085,
	"./search.svg": 712,
	"./searchIcon.svg": 1086,
	"./seat-icon-2.svg": 1087,
	"./seat-icon.svg": 1088,
	"./seat-icons/3-wheelChair.png": 1089,
	"./seat-icons/block_seat_new.png": 1090,
	"./seat-icons/broken-seat-1.svg": 1091,
	"./seat-icons/broken-seat-2.svg": 1092,
	"./select-food.png": 713,
	"./settings.svg": 1093,
	"./show-password.svg": 357,
	"./slider-triangle.svg": 1094,
	"./snack.svg": 706,
	"./sort.svg": 1095,
	"./star-empty.svg": 1096,
	"./star-fill.svg": 1097,
	"./success-tick.svg": 1098,
	"./suitcase.svg": 1099,
	"./swap.svg": 1100,
	"./tick-green-item.svg": 714,
	"./tick-green.svg": 1101,
	"./ticket-icon.svg": 1102,
	"./trash.svg": 1103,
	"./unpaid-reservation.svg": 689,
	"./updown-white.svg": 1104,
	"./updown.svg": 1105,
	"./user-attribute.svg": 1106,
	"./user-attributes.svg": 1107,
	"./user-female.svg": 1108,
	"./user-male-white.svg": 1109,
	"./user-male.svg": 1110,
	"./user-profile.svg": 1111,
	"./userProfile.png": 1112,
	"./veg-food-mark-white.png": 1113,
	"./veg-foog-mark-trans.png": 1114,
	"./view.png": 1115,
	"./view.svg": 1116
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 939;


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons ^\.\/.*$
// module id = 939
// module chunks = 34